/**
 * SoliticsPopupContent represents the payload recived via websocket
 */
export class SoliticsPopupContent {
    /**
     * @param {String} messageID - The unique ID of the message
     * @param {String} messageHTML - The HTML content of the message
     * @param {object} webhookParams - An object with string keys and values of any type
     * @param {object} rawWebhookPayload - An object with string keys and string values
     */
    constructor(messageID, messageHTML, webhookParams = {}, rawWebhookPayload = {}) {
        this._messageID = messageID;
        this._messageHTML = messageHTML;
        this._webhookParams = webhookParams;
        this._rawWebhookPayload = rawWebhookPayload;
    }
    // Getter for messageID
    get messageID() {
        return this._messageID;
    }
    // Getter for messageHTML
    get messageHTML() {
        return this._messageHTML;
    }
    // Getter for webhookParams
    get webhookParams() {
        return this._webhookParams;
    }
    // Getter for rawWebhookPayload
    get rawWebhookPayload() {
        return this._rawWebhookPayload;
    }
    /**
     * Convert a plain object to a SoliticsPopupContent instance
     * @param {object} data - The plain object to convert
     * @returns {SoliticsPopupContent} - The resulting SoliticsPopupContent instance
     */
    static fromObject(data) {
        return new SoliticsPopupContent(data.messageID || "", data.messageHTML || "", data.webhookParams || {}, data.rawWebhookPayload || {});
    }
}
;
